import { Component, OnInit } from '@angular/core'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { CheckoutCostCenterFacade, CheckoutPaymentTypeFacade } from '@spartacus/checkout/b2b/root'
import { CheckoutStepService } from '@spartacus/checkout/base/components'
import {
  CheckoutDeliveryAddressFacade,
  CheckoutDeliveryModesFacade,
  CheckoutPaymentFacade
} from '@spartacus/checkout/base/root'
import { TranslationService, UserCostCenterService } from '@spartacus/core'
import { SharedService } from '../../../services/shared/shared.service'
import { B2BCheckoutReviewSubmitComponent } from '@spartacus/checkout/b2b/components'

@Component({
    selector: 'app-custom-review-submit',
    templateUrl: './custom-review-submit.component.html',
    styleUrls: ['./custom-review-submit.component.scss'],
    standalone: false
})
export class CustomReviewSubmitComponent extends B2BCheckoutReviewSubmitComponent implements OnInit {
  constructor(
    protected checkoutDeliveryAddressFacade: CheckoutDeliveryAddressFacade,
    protected checkoutPaymentFacade: CheckoutPaymentFacade,
    protected activeCartFacade: ActiveCartFacade,
    protected translationService: TranslationService,
    protected checkoutStepService: CheckoutStepService,
    protected checkoutDeliveryModesFacade: CheckoutDeliveryModesFacade,
    protected checkoutPaymentTypeFacade: CheckoutPaymentTypeFacade,
    protected checkoutCostCenterFacade: CheckoutCostCenterFacade,
    protected userCostCenterService: UserCostCenterService,
    public sharedService: SharedService
  ) {
    super(
      checkoutDeliveryAddressFacade,
      checkoutPaymentFacade,
      activeCartFacade,
      translationService,
      checkoutStepService,
      checkoutDeliveryModesFacade,
      checkoutPaymentTypeFacade,
      checkoutCostCenterFacade,
      userCostCenterService
    )
  }

  ngOnInit(): void {}
}
